
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import DialogCustomer from '@/components/CustomerDialog/levelByLevel.vue';
import DialogDept from '@/components/DeptDialog/index.vue';
import FaultDialog from '@/components/FaultDialog/index.vue';
import OrderTag from '@/views/order/components/OrderTag.vue'
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'TaskSearchItem',
  components: {
    DialogCustomer,
    DialogDept,
    FaultDialog,
    OrderTag
  }
})
export default class extends Vue {
  @Prop({
    type: Object,
    default: () => {}
  })
  searchData!: any;

  private taskStatusOptions =[{
    label: '待签到',
    value: 1
  }, {
    label: '待收货',
    value: 2
  }, {
    label: '待完成',
    value: 8
  }]
  private orderStatusOptions=[{
    label: '订单已完结',
    value: 4
  }, {
    label: '订单未完结',
    value: 16
  }]
  private dealWayOptions = [{
    label: '送修',
    value: 5
  }, {
    label: '远程',
    value: 1
  }, {
    label: '上门',
    value: 2
  }, {
    label: '寄修',
    value: 3
  }, {
    label: '转派',
    value: 4
  }, {
    label: '其他',
    value: 9
  }]
  private pickerOptions:any = {
    shortcuts: [{
      text: '今天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); //
        const end = new Date(today); 
        const start = new Date(today); 
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '昨天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近7天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近30天',
      onClick(picker: any) {
     const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }]
  }
  private serverCompanyId=''
  created() {
    this.serverCompanyId = UserModule.getCompanyId;
  }
  // 部门
  private deptReadonly = false;
  private departmentVisible = false
  private deptType = 1
  @Watch("departmentVisible")
  getDepartmentVisible(val: boolean) {
    if (val) {
      this.deptReadonly = true;
    } else {
      this.deptReadonly = false;
    }
  }
  private selectedDeptCustomer() {
    this.deptType = 1;
    this.departmentVisible = true;
  }
  private selectedDeptServicer() {
    this.deptType = 2;
    this.departmentVisible = true;
  }
  private departmentDialogClose(val: any) {
    this.departmentVisible = val;
  }
  private departmentSelected(val: any) {
    this.searchData.fields = {};
    this.searchData.fields.name = val.name;
    this.searchData.fields.id = val.id;
    this.changeData();
  }
  private clearDept() {
    this.searchData.fields = {};
    this.searchData.fields.name = '';
    this.searchData.fields.id = '';
    this.changeData();
  }

  // 客户
  private customerVisible = false
  private customerReadonly = false;
  @Watch("customerVisible")
  getCustomerVisible(val: boolean) {
    if (val) {
      this.customerReadonly = true;
    } else {
      this.customerReadonly = false;
    }
  }
  selectCustomerHandle() {
    this.customerVisible = true;
  }
  selectcustomer(val: any) {
    this.searchData.fields = {};
    this.searchData.fields = val;
    this.changeData();
  }
  customerClose(val: any) {
    this.customerVisible = val;
  }
  private clearCustomer() {
    this.searchData.fields = {};
    this.changeData();
  }
  // 故障
  private faultType = "1";
  private faultReadonly = false;
  private faultVisible = false;
  @Watch("faultVisible")
  getFaultVisible(val: boolean) {
    if (val) {
      this.faultReadonly = true;
    } else {
      this.faultReadonly = false;
    }
  }
  private faultSelected(val: any) {
    this.searchData.fields = {};
    this.searchData.fields.name = val.name;
    this.searchData.fields.id = val.id;
    this.changeData();
    // switch (parseInt(val.type)) {
    //   case 1:
    //     this.orderForm.faultType = val.name;
    //     this.orderForm.faultTypeId = val.id;
    //     break;
    //   case 2:
    //     this.orderForm.faultPhenomenon = val.name;
    //     this.orderForm.faultPhenomenonId = val.id;
    //     break;
    // }
  }
  private faultDialogClose(val: any) {
    this.faultVisible = val;
  }
  private clearFault() {
    this.searchData.fields = {};
    this.searchData.fields.name = '';
    this.searchData.fields.id = '';
    this.changeData();
  }
  // 标签
  private tagReadonly = false;
  private tagVisible = false
  @Watch("tagVisible")
  getTagVisible(val: boolean) {
    if (val) {
      this.tagReadonly = true;
    } else {
      this.tagReadonly = false;
    }
  }
  private closeTagHandle(value:boolean) {
    this.tagVisible = value;
  }
  private confirmTagHandle(val:any) {
    this.tagVisible = false;
    this.searchData.fields = {};
    this.searchData.fields.name = val.name;
    this.searchData.fields.id = val.tags_id;
    this.changeData();
  }
  private clearTag() {
    this.searchData.fields = {};
    this.searchData.fields.name = '';
    this.searchData.fields.id = '';
    this.changeData();
  }

  private changeData() {
    this.$emit('receiveData', this.searchData);
  }

  private keyupHandle() {
    this.$emit('receiveData', this.searchData, true);
  }
}
